import { oneLine } from 'common-tags/es';

const data = {
    type: 'homepage',
    path: '/',
    title: 'The dream',
    content: [
        oneLine`All tamariki, no matter their <br class="hidden md+:inline" />
                background, deserve the support <br class="hidden md+:inline" />
                and opportunity to flourish.`,
        oneLine`Just as we came together to keep safe <br class="hidden md+:inline" />
                from COVID-19, we can choose to solve poverty and set <br class="hidden md+:inline" />
                a better course for the future of all tamariki.`,
        oneLine`Working <br class="hidden md+:inline" />
                together, we must <br class="hidden md+:inline" />
                act now.`,
    ],
    meta: {
        title: 'Tracking progress on reducing child poverty in New Zealand | Child Poverty',
    },
    tilesGroups: [
        {
            name: 'first-tile-group',
            first: true,
            heading: oneLine`Are we closer to eliminating <br class="hidden sm:inline" />
                    child poverty in Aotearoa <br class="hidden sm:inline" />
                    New Zealand?`,
            subheading: oneLine`2020 has been a year like no other*. Scroll down to find out more.`,
            leftToRight: false,
            animations: [
                {
                    filename: 'cloud-5.png',
                    type: 'css',
                    width: '15%',
                    top: '2%',
                    left: '3%',
                    mobileWidth: '45%',
                    mobileTop: '10%',
                    mobileLeft: '-20%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-2.png',
                    type: 'css',
                    width: '20%',
                    top: '7%',
                    left: '80%',
                    mobileWidth: '50%',
                    mobileTop: '0%',
                    mobileLeft: '80%',
                    animation: '5s linear 1s infinite bob-2',
                },
                {
                    filename: 'cloud-6.png',
                    type: 'css',
                    width: '15%',
                    top: '35%',
                    left: '75%',
                    mobileWidth: '50%',
                    mobileTop: '40%',
                    mobileLeft: '80%',
                    animation: '5s linear infinite bob-2',
                },
                {
                    filename: 'cloud-3.png',
                    type: 'css',
                    width: '15%',
                    top: '45%',
                    left: '-10%',
                    mobileWidth: '55%',
                    mobileTop: '40%',
                    mobileLeft: '-40%',
                    animation: '5s linear 3s infinite bob-1',
                },
                {
                    filename: 'cloud-2.png',
                    type: 'css',
                    width: '20%',
                    top: '52%',
                    left: '90%',
                    mobileWidth: '50%',
                    mobileTop: '60%',
                    mobileLeft: '90%',
                    animation: '5s linear 2s infinite bob-2',
                },
                {
                    filename: 'cloud-7.png',
                    type: 'css',
                    width: '15%',
                    top: '80%',
                    left: '3%',
                    mobileWidth: '40%',
                    mobileTop: '82%',
                    mobileLeft: '-25%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-10.png',
                    type: 'css',
                    width: '10%',
                    top: '75%',
                    left: '83%',
                    mobileWidth: '25%',
                    mobileTop: '90%',
                    mobileLeft: '90%',
                    animation: '5s linear infinite bob-2',
                },
            ],
            tiles: [
                {
                    filename: '1_Welcome.png',
                    mobileFilename: '1_Welcome_mobile.png',
                    animations: [
                        {
                            filename: '01 HEALTH - Tree.json',
                            type: 'lottie',
                            loop: true,
                            width: '15%',
                            top: '17.2%',
                            left: '30.7%',
                            mobileTop: '8%',
                            mobileLeft: '34.5%',
                        },
                    ],
                },
                {
                    filename: '2_Covid.png',
                    mobileFilename: '2_Covid_mobile.png',
                    offset: '33.5%',
                    mobileOffset: '1rem',
                    animations: [
                        {
                            filename: '09 COVID - SoccerMum.json',
                            type: 'lottie',
                            loop: true,
                            width: '88%',
                            top: '11%',
                            left: '3%',
                            mobileTop: '-3%',
                            mobileLeft: '3%',
                        },
                        {
                            filename: '09 COVID - SoccerBoy.json',
                            type: 'lottie',
                            loop: true,
                            width: '15%',
                            top: '33%',
                            left: '34%',
                            mobileTop: '28%',
                            mobileLeft: '33%',
                        },
                        {
                            filename: '09 COVID - ZoomBoy.json',
                            type: 'lottie',
                            loop: true,
                            width: '100%',
                            top: '5%',
                            left: '-3%',
                            mobileTop: '-13%',
                            mobileLeft: '-6%',
                        },
                        {
                            filename: '09 COVID - ZoomGirl.json',
                            type: 'lottie',
                            loop: true,
                            width: '24.4%',
                            top: '45.5%',
                            left: '69.7%',
                            mobileTop: '45%',
                            mobileLeft: '66%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'The Effects of COVID-19',
                            number: 1,
                            showTitle: true,
                            first: true,
                            position: 'bottom',
                            top: '22%',
                            left: '30%',
                            mobileTop: '16%',
                            mobileLeft: '55%',
                            width: '384px',
                            height: '220px',
                            content: oneLine`COVID-19 has highlighted existing inequalities in Aotearoa New Zealand, 
                                    sometimes making them worse.`,
                            link: '/measures/covid',
                        },
                    ],
                },
                {
                    filename: '3_Income.png',
                    mobileFilename: '3_Income_mobile.png',
                    mobileOffset: '1rem',
                    animations: [
                        {
                            filename: '02 INCOME - Bird.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '5%',
                            left: '10%',
                            mobileTop: '0%',
                            mobileLeft: '16%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Adequate income',
                            number: 1,
                            showTitle: true,
                            first: true,
                            position: 'bottom',
                            top: '-18%',
                            left: '38%',
                            mobileTop: '16%',
                            mobileLeft: '55%',
                            width: '320px',
                            mobileWidth: '',
                            height: '275px',
                            content: [
                                oneLine`<b>20.8%</b> of tamariki live in low-income households.`,
                                oneLine`The Government has committed to reducing this to <b>10%</b> by 2028.`,
                            ],
                            link: '/measures/income',
                        },
                    ],
                },
                {
                    filename: '4_Essentials.png',
                    mobileFilename: '4_Essentials_mobile.png',
                    offset: '5%',
                    mobileOffset: '2rem',
                    animations: [
                        {
                            filename: '03 ESSENTIALS - PersonJumping.json',
                            type: 'lottie',
                            loop: true,
                            width: '30%',
                            top: '33%',
                            left: '28%',
                            mobileTop: '26%',
                            mobileLeft: '26%',
                            noAnimateIE: true,
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Access to essentials',
                            number: 3,
                            showTitle: true,
                            position: 'bottom',
                            top: '-12%',
                            left: '10%',
                            mobileTop: '5%',
                            mobileLeft: '38%',
                            width: '448px',
                            mobileWidth: '',
                            height: '275px',
                            content: [
                                oneLine`<b>13.4%</b> of tamariki live in households experiencing material hardship.`,
                                oneLine`The Government has committed to reduce the proportion of tamariki living in 
                                    material hardship to <b>6%</b> by 2028.`,
                            ],
                            link: '/measures/essentials',
                        },
                    ],
                },
                {
                    filename: '5_Health.png',
                    mobileFilename: '5_Health_mobile.png',
                    animations: [
                        {
                            filename: '04 HEALTH - Chopper.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '-10%',
                            left: '10%',
                            mobileTop: '-5%',
                            mobileLeft: '38%',
                        },
                        {
                            filename: '04 HEALTH - Inhaler.json',
                            type: 'lottie',
                            loop: true,
                            width: '60%',
                            top: '57%',
                            left: '49%',
                            mobileTop: '53%',
                            mobileLeft: '52%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Good health',
                            number: 6,
                            showTitle: true,
                            top: '5%',
                            left: '32%',
                            mobileTop: '67%',
                            mobileLeft: '38%',
                            width: '376px',
                            height: '240px',
                            content: oneLine`Tamariki living in areas with the highest deprivation scores are 
                                    <b>twice as likely</b> to end up in hospital than tamariki in areas with the lowest 
                                    deprivation scores.`,
                            link: '/measures/health',
                        },
                    ],
                },
                {
                    filename: '6_Home.png',
                    mobileFilename: '6_Home_mobile.png',
                    animations: [
                        {
                            filename: '05 HOME - Roof.json',
                            type: 'lottie',
                            loop: true,
                            width: '45%',
                            top: '35%',
                            left: '25%',
                            mobileTop: '10%',
                            mobileLeft: '26%',
                        },
                        {
                            filename: '05 HOME - Swing.json',
                            type: 'lottie',
                            loop: true,
                            width: '30%',
                            top: '45%',
                            left: '2%',
                            mobileTop: '24%',
                            mobileLeft: '6%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'A place to call home',
                            number: 7,
                            showTitle: true,
                            top: '2%',
                            left: '0%',
                            mobileTop: '72%',
                            mobileLeft: '13%',
                            width: '380px',
                            height: '370px',
                            content: [
                                oneLine`High housing costs contribute to many whānau living in poverty. 
                                    <b>More than 30%</b> of the lowest income households with tamariki spend more than half of 
                                    their income on housing costs.`,
                                oneLine`Around <b>25%</b> of tamariki live in houses that are sometimes damp and 
                                    <b>18%</b> in houses that sometimes have mould.`,
                            ],
                            link: '/measures/home',
                        },
                    ],
                },
                {
                    filename: '7_Food.png',
                    mobileFilename: '7_Food_mobile.png',
                    animations: [
                        {
                            filename: '06 FOOD - Trolley.json',
                            type: 'lottie',
                            loop: true,
                            width: '58%',
                            top: '20%',
                            left: '11%',
                            mobileTop: '5%',
                            mobileLeft: '21%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Healthy food',
                            number: 8,
                            showTitle: true,
                            position: 'bottom',
                            top: '-8%',
                            left: '32%',
                            mobileTop: '9%',
                            mobileLeft: '65%',
                            width: '320px',
                            height: '300px',
                            content: oneLine`<b>56%</b> of tamariki living in whānau receiving financial assistance don't 
                                always have enough healthy food to eat, compared to just 12% of tamariki living in 
                                whānau not receiving financial assistance.`,
                            link: '/measures/food',
                        },
                    ],
                },
            ],
        },
        {
            name: 'second-tile-group',
            heading: 'What needs to change?',
            subheading: [
                oneLine`Poverty continues to unfairly constrain the lives of too many tamariki and their whānau in 
                    Aotearoa New Zealand. COVID-19 has highlighted existing inequalities in Aotearoa <br class="hidden md+:inline" />
                    New Zealand, sometimes making them worse.`,
                oneLine`Poverty limits opportunities and choices and creates toxic stress that can make daily life 
                    unbearable. It fractures relationships, undermines health and education, and can make it almost 
                    impossible to get out of survival mode.`,
                oneLine`We can choose to solve poverty and set a better course for the future of all tamariki.`,
            ],
            offset: '10%',
            mobileOffset: '4rem',
            leftToRight: true,
            animations: [
                {
                    filename: 'cloud-1.png',
                    type: 'css',
                    width: '15%',
                    top: '60%',
                    left: '3%',
                    mobileWidth: '50%',
                    mobileTop: '50%',
                    mobileLeft: '-30%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-5.png',
                    type: 'css',
                    width: '15%',
                    top: '83%',
                    left: '55%',
                    mobileWidth: '50%',
                    mobileTop: '-5%',
                    mobileLeft: '85%',
                    animation: '5s linear 0.5s infinite bob-1',
                },
                {
                    filename: 'cloud-4.png',
                    type: 'css',
                    width: '15%',
                    top: '65%',
                    left: '40%',
                    mobileWidth: '60%',
                    mobileTop: '35%',
                    mobileLeft: '80%',
                    animation: '5s linear infinite bob-1',
                },
            ],
            tiles: [
                {
                    filename: '8_Policy.png',
                    mobileFilename: '8_Policy_mobile.png',
                    animations: [
                        {
                            filename: '07 POLICY - ProtestorStanding.json',
                            type: 'lottie',
                            loop: true,
                            width: '15%',
                            top: '23%',
                            left: '10%',
                            mobileTop: '20%',
                            mobileLeft: '11%',
                        },
                        {
                            filename: '07 POLICY - ProtestorWheelchair.json',
                            type: 'lottie',
                            loop: true,
                            width: '18%',
                            top: '61%',
                            left: '27%',
                            mobileTop: '59%',
                            mobileLeft: '27%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Policy',
                            number: 10,
                            showTitle: true,
                            position: 'bottom',
                            top: '-23%',
                            left: '13%',
                            mobileTop: '5%',
                            mobileLeft: '29%',
                            width: '320px',
                            height: '230px',
                            content: oneLine`One of the best ways to reduce the number of tamariki in poverty is to 
                                <b>raise whānau incomes</b> by increasing benefits.`,
                        },
                    ],
                },
                {
                    filename: '9_Future.png',
                    mobileFilename: '9_Future_mobile.png',
                    offset: '50%',
                    mobileOffset: '2rem',
                    animations: [
                        {
                            filename: '08 FUTURE - Tree.json',
                            type: 'lottie',
                            loop: true,
                            width: '20%',
                            top: '-1.2%',
                            left: '57.6%',
                            mobileTop: '-2.4%',
                            mobileLeft: '57%',
                        },
                        {
                            filename: '08 FUTURE - Beachball.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '-2%',
                            left: '11%',
                            mobileTop: '-8%',
                            mobileLeft: '13%',
                            noAnimateIE: true,
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Hope for the future',
                            number: 11,
                            showTitle: true,
                            position: 'bottom',
                            top: '9%',
                            left: '18%',
                            mobileTop: '-6%',
                            mobileLeft: '45%',
                            width: '416px',
                            height: '250px',
                            content: oneLine`Our response to COVID-19 has shown us what’s possible when we work 
                                together and look out for each other. Current and future governments can choose to 
                                invest in solutions that unlock the constraints of poverty. Working together we can 
                                set a course for a better future where everyone flourishes.`,
                        },
                    ],
                },
            ],
        },
        {
            name: 'third-tile-group',
            heading: 'About the Child Poverty Monitor',
            mobileOffset: '4rem',
            subheading: oneLine`The annual Child Poverty Monitor reports on child <br class="hidden sm:inline" />
                poverty in Aotearoa New Zealand and its impacts. <br class="hidden sm:inline" />
                <a class="font-semibold underline-link" href="/about">Click to find out more</a>.`,
        },
    ],
};

export default data;
